export enum StateOfEvent {
  Off = 'off',
  On = 'on',
}
